/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `m/s` - meter_per_second
 * * `mm/h` - millimeter_per_hour
 * * `mm/min` - millimeter_per_minute
 * @export
 */
export const LocalRainUnitEnum = {
  M_S: "m/s",
  MM_H: "mm/h",
  MM_MIN: "mm/min",
} as const;
export type LocalRainUnitEnum = (typeof LocalRainUnitEnum)[keyof typeof LocalRainUnitEnum];

export function instanceOfLocalRainUnitEnum(value: any): boolean {
  for (const key in LocalRainUnitEnum) {
    if (Object.prototype.hasOwnProperty.call(LocalRainUnitEnum, key)) {
      if (LocalRainUnitEnum[key as keyof typeof LocalRainUnitEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function LocalRainUnitEnumFromJSON(json: any): LocalRainUnitEnum {
  return LocalRainUnitEnumFromJSONTyped(json, false);
}

export function LocalRainUnitEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): LocalRainUnitEnum {
  return json as LocalRainUnitEnum;
}

export function LocalRainUnitEnumToJSON(value?: LocalRainUnitEnum | null): any {
  return value as any;
}

export function LocalRainUnitEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): LocalRainUnitEnum {
  return value as LocalRainUnitEnum;
}
